export default __webpack_public_path__ + "static/media/@eu.kaholiveira.ce7a7723.jpg";